import parsePhoneNumberFromString from "libphonenumber-js/min";

const COUNTRY_MAP = {
	"+1": "US",
	"+54": "AR",
	"+55": "BR",
	"+57": "CO",
	"+33": "FR",
	"+49": "DE",
	"+91": "IN",
	"+62": "ID",
	"+52": "MX",
	"+51": "PE",
	"+63": "PH",
	"+34": "ES",
	"+380": "UA",
	"+44": "GB",
};

export function parseCountryValue(val) {
	if (!val || val.includes("Other") || val === "+") {
		return { iso: null, code: null, isOther: true };
	}

	const code = val.trim();
	const iso = COUNTRY_MAP[code] || null;

	return {
		iso: iso,
		code: code,
		isOther: false,
	};
}

export function validatePhoneNumber(phone, countryIso, isOther = false, selectedCountryCode = null) {
	let cleanPhone = (phone || "").trim();

	if (!cleanPhone || cleanPhone === "+") return { isValid: false };

	// First, remove spaces, parentheses, and hyphens
	let libraryPhone = cleanPhone.replace(/[\s\-()]/g, "");

	try {
		let parsed;

		if (countryIso && !isOther && selectedCountryCode) {
			const cleanCode = selectedCountryCode.trim();

			// If the number starts with the selected country code, we trim it to ensure the library works correctly
			if (libraryPhone.startsWith(cleanCode)) {
				libraryPhone = libraryPhone.substring(cleanCode.length);
			}
			// console.log(`[Validator] Checking ${countryIso}: passing the number to the library -> ${libraryPhone}`);

			parsed = parsePhoneNumberFromString(libraryPhone, countryIso);
		} else {
			if (!libraryPhone.startsWith("+")) {
				libraryPhone = "+" + libraryPhone;
			}
			parsed = parsePhoneNumberFromString(libraryPhone);
		}

		if (!parsed || !parsed.isValid()) {
			return { isValid: false };
		}

		return {
			isValid: true,
			formatted: parsed.number,
			region: parsed.country,
		};
	} catch (e) {
		// console.error("[Validator] Error calling the libphonenumber library:", e);
		return { isValid: false };
	}
}

export function initCountryCodeDisplay() {
	$(document).on("change", "[name=country-code]", function () {
		const { code } = parseCountryValue($(this).val() || "");
		const $form = $(this).closest("form");
		let $display = $form.find(".country-code-display");

		if (!$display.length) {
			$display = $('<div class="country-code-display"></div>');
			$(this).closest(".form-field").append($display);
		}
		$display.text(code || "");
	});
}
